import { ENUM_STATUS_ATIVO, ENUM_STATUS_IS_SETORIAL, ENUM_CONDICAO_STATUS, ENUM_CARGO } from 'utils/consts';
import { cpfMaskView } from 'utils/masks';
import { removeTodasMascaras } from 'utils/stringFormatter';

export const formatterAtendenteBackToFront = atendenteApi => {
  return {
    id: atendenteApi?.id || '',
    cpf: cpfMaskView(atendenteApi?.documento),
    nome: atendenteApi?.nome || '',
    apelido: atendenteApi?.apelido || '',
    email: atendenteApi?.email || '',
    cargo: atendenteApi?.cargoId || '',
    situacaoId: atendenteApi?.situacaoId || ENUM_STATUS_ATIVO.ATIVO.value,
    isSetorial:
      atendenteApi?.isSetorial === true ? ENUM_STATUS_IS_SETORIAL.SIM.value : ENUM_STATUS_IS_SETORIAL.NAO.value,
    setoresIds: atendenteApi?.setores?.map(s => s?.id),
    condicaoStatusId: atendenteApi?.condicaoId,
  };
};

export const formatterAtendenteFrontToBackCreate = dadosInputs => {
  const cpf = parseInt(removeTodasMascaras(dadosInputs?.cpf), 10);
  const cargo = parseInt(dadosInputs?.cargo, 10);
  const status = parseInt(dadosInputs?.situacaoId, 10) || ENUM_STATUS_ATIVO.ATIVO.value;
  const isSetorial =
    dadosInputs?.isSetorial === ENUM_STATUS_IS_SETORIAL.SIM.value
      ? ENUM_STATUS_IS_SETORIAL.SIM.id
      : ENUM_STATUS_IS_SETORIAL.NAO.id;
  return {
    documento: cpf,
    nome: dadosInputs?.nome,
    apelido: dadosInputs?.apelido,
    email: dadosInputs?.email,
    cargoId: cargo,
    situacaoId: status,
    isSetorial: isSetorial,
    setorIds: dadosInputs?.setoresIds,
    condicaoId: dadosInputs?.condicaoStatusId,
    id: 0,
  };
};

export const formatterAtendenteFrontToBackUpdate = (dadosInputs, cpfUsuarioLogado) => {
  const id = parseInt(dadosInputs?.id, 10);
  const cpf = parseInt(removeTodasMascaras(cpfUsuarioLogado), 10);
  const cargo = parseInt(dadosInputs?.cargo, 10);
  const status = parseInt(dadosInputs?.situacaoId, 10) || ENUM_STATUS_ATIVO.ATIVO.value;
  const isSetorial =
    dadosInputs?.isSetorial === ENUM_STATUS_IS_SETORIAL.SIM.value
      ? ENUM_STATUS_IS_SETORIAL.SIM.id
      : ENUM_STATUS_IS_SETORIAL.NAO.id;
  let setorIds = dadosInputs?.isSetorial === ENUM_STATUS_IS_SETORIAL.NAO.value ? null : dadosInputs?.setoresIds;
  return {
    cpfUsuarioLogado: cpf,
    nome: dadosInputs?.nome,
    apelido: dadosInputs?.apelido,
    email: dadosInputs?.email,
    cargoId: cargo,
    situacaoId: status,
    isSetorial: isSetorial,
    setorIds: setorIds,
    condicaoId: dadosInputs?.condicaoStatusId,
    id: id,
  };
};

export const formatterAtendenteBackToBackUpdate = (atendenteApi, cpfUsuarioLogado) => {
  const cpf = parseInt(removeTodasMascaras(cpfUsuarioLogado), 10);

  return {
    cpfUsuarioLogado: cpf,
    nome: atendenteApi?.nome,
    apelido: atendenteApi?.apelido,
    email: atendenteApi?.email,
    cargoId: atendenteApi?.cargoId,
    situacaoId: atendenteApi?.situacaoId,
    isSetorial: atendenteApi?.isSetorial,
    setorIds: atendenteApi?.setores.map(item => item.id),
    id: atendenteApi?.id,
    condicaoId: atendenteApi?.condicaoId,
  };
};

export const formatterAtendenteNull = isSetorial => {
  return {
    id: '',
    cpf: '',
    nome: '',
    apelido: '',
    email: '',
    cargo: isSetorial ? ENUM_CARGO.ATENDENTE : '',
    situacaoId: ENUM_STATUS_ATIVO.ATIVO.value,
    isSetorial: isSetorial ? ENUM_STATUS_IS_SETORIAL.SIM.value : ENUM_STATUS_IS_SETORIAL.NAO.value,
    setoresIds: [],
    condicaoStatusId: isSetorial ? ENUM_CONDICAO_STATUS.SOLICITADO.id : ENUM_CONDICAO_STATUS.APROVADO.id,
  };
};
